module.exports = __webpack_public_path__ + "static/media/trag.e38d26d6.gif";